export default "__VITE_ASSET__BOziJ0L3__"